
























































import Vue, { PropOptions } from 'vue';

export type BentoCard = Blok & {
  showTitle: boolean;
  showText: boolean;
  variant: 'icon' | 'top-image' | 'bottom-image';
  title: string;
  titleFontSize: string;
  text: string;
  image: BlokFieldAsset;
  imageFullWidth: boolean;
  button: Blok[];
  fullWidth: boolean;
  desktopWidth: number;
  tabletWidth: number;
  topColor: {
    value: string;
  };
  bottomColor: {
    value: string;
  };
  desktopOrder: number;
  mobileOrder: number;
  url?: BlokFieldLink;
};

export type BentoCardComponentInstance = Vue & {
  blok: BentoCard;
  computeWidthStyle: (width: number) => string;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<BentoCard>,
  },
  methods: {
    computeWidthStyle(width: number) {
      if (width === 100) {
        return '100%';
      } else if (width > 34) {
        return `calc(${width}% - var(--spacing-md) / 2)`;
      } else {
        return `calc(${width}% - var(--spacing-md) * 2 / 3)`;
      }
    },
    onClick() {
      const url = this.url();
      if (url) {
        this.$router.push('/' + url);
      }
    },
    url() {
      if (!this.blok.url) {
        return null;
      }
      const { cached_url, url } = this.blok.url;
      try {
        const resultUrl = new URL(cached_url || url);
        const currentSearchParams = new URLSearchParams(window.location.search);
        for (const [key, value] of currentSearchParams.entries()) {
          resultUrl.searchParams.set(key, value);
        }
        return resultUrl.toString();
      } catch (e) {
        return cached_url || url;
      }
    },
  },
  computed: {
    cardStyle(this: BentoCardComponentInstance) {
      return {
        '--desktop-width': this.computeWidthStyle(this.blok.desktopWidth),
        '--tablet-width': this.computeWidthStyle(this.blok.tabletWidth),
        '--top-color': this.blok.topColor?.value,
        '--bottom-color': this.blok.bottomColor?.value,
        '--desktop-order': this.blok.desktopOrder,
        '--mobile-order': this.blok.mobileOrder,
      };
    },
  },
});
